import { Store } from "pullstate";

export interface IOrganizationContext {
  id: string;
  name: string | undefined;
  displayName: string | undefined;
  organizationTypeId: string;
}

export type ContextStore = {
  organization?: IOrganizationContext;
};

const contextStore = new Store<ContextStore>({});

export default contextStore;
